import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { PlayButtonController } from './play-button.controller';
import { faPlay } from '@fortawesome/pro-solid-svg-icons/faPlay';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgStyle } from '@angular/common';
import { SecondsToMinutesPipe } from '@hidat/ng-common';

/**
 * Renders a play button with play icon on the left, duration on the right.
 */
@Component({
  selector: 'pv2-duration-play-button',
  templateUrl: 'duration-play-button.component.html',
  styleUrl: 'play-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [FaIconComponent, NgStyle, SecondsToMinutesPipe],
})
export class Pv2DurationPlayButtonComponent extends PlayButtonController {
  public readonly duration = input<number | undefined>(undefined);

  constructor() {
    super();
    this.faPlay = faPlay;
  }
}
